import { render, staticRenderFns } from "./RoleGroupModal.vue?vue&type=template&id=f328de82"
import script from "./RoleGroupModal.ts?vue&type=script&lang=ts&external"
export * from "./RoleGroupModal.ts?vue&type=script&lang=ts&external"
import style0 from "./RoleGroupModal.vue?vue&type=style&index=0&id=f328de82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports